/* I NEED GOD · floating 11% cherub
   Flies in after a few seconds (or a little scrolling) on the homepage and collection pages.
   The X hides it for a while; once someone signs up (here or in Bless Yourself) it never comes back.
   Sign-up goes through the app, which adds the e-mail with consent and makes a one-time code.
   If the app can't be reached, the store's own sign-up form is sent instead so nobody is lost. */
(function () {
  var HIDE = 'ing-cherub-hide-until', DONE = 'ing-offer-done', DAY = 864e5;
  function get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function set(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  function esc(t) { var d = document.createElement('div'); d.textContent = t == null ? '' : String(t); return d.innerHTML; }
  function post(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { j.__status = r.status; return j; }); });
  }
  function fit(el) {
    el.style.fontSize = '';
    var fs = parseFloat(getComputedStyle(el).fontSize) || 20, n = 0;
    while (el.scrollWidth > el.clientWidth + 1 && fs > 9 && n++ < 30) { fs -= 1; el.style.fontSize = fs + 'px'; }
  }

  function init(root) {
    if (root.__ingCherub) return; root.__ingCherub = true;
    var d = root.dataset, editor = d.editor === 'true';
    var quick = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    var float = root.querySelector('[data-float]'), sheet = root.querySelector('[data-sheet]');
    var dim = root.querySelector('[data-dim]'), body = root.querySelector('[data-body]');
    var form = body.querySelector('form'), sheetSign = root.querySelector('[data-sheet-sign]');
    var signedUp = false, lastFocus = null, shown = false;
    function fitAll() { root.querySelectorAll('[data-fit]').forEach(fit); }

    /* ----- open / close ----- */
    function focusables() { return Array.prototype.filter.call(sheet.querySelectorAll('a[href],button:not([disabled]),input:not([type=hidden])'), function (el) { return el.offsetParent !== null; }); }
    function onKey(e) {
      if (e.key === 'Escape') { e.preventDefault(); close(); return; }
      if (e.key !== 'Tab') return;
      var f = focusables(); if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    function open() {
      lastFocus = document.activeElement;
      root.classList.add('is-open');
      document.addEventListener('keydown', onKey);
      fitAll();
      // focus the sheet itself, not the e-mail field: the phone keyboard stays down and
      // Shopify's spam check only wakes up once they actually tap the field
      if (!sheet.hasAttribute('tabindex')) sheet.setAttribute('tabindex', '-1');
      setTimeout(function () { sheet.focus({ preventScroll: true }); }, quick ? 0 : 300);
    }
    function close() {
      root.classList.remove('is-open');
      document.removeEventListener('keydown', onKey);
      if (signedUp) { retire(); return; }
      if (lastFocus && lastFocus.focus && document.contains(lastFocus)) lastFocus.focus({ preventScroll: true });
    }
    function retire() {
      float.classList.add('is-gone');
      setTimeout(function () { root.classList.add('is-off'); }, quick ? 250 : 900);
    }
    function hide() {
      if (!editor) set(HIDE, String(Date.now() + (parseInt(d.days, 10) || 14) * DAY));
      retire();
    }

    root.querySelector('[data-open]').addEventListener('click', open);
    root.querySelector('[data-hide]').addEventListener('click', hide);
    root.querySelector('[data-close]').addEventListener('click', close);
    dim.addEventListener('click', close);
    var no = root.querySelector('[data-nothanks]');
    if (no) no.addEventListener('click', function () { close(); hide(); });
    // signed up somewhere else on the page (Bless Yourself)? Then fly off for good.
    document.addEventListener('ing:subscribed', function (e) { if (e.detail && e.detail.from === 'cherub') return; signedUp = true; if (!root.classList.contains('is-open')) retire(); });

    /* ----- came back from the store's own form (the backup path) ----- */
    if (root.querySelector('[data-posted]')) {
      set(DONE, '1'); signedUp = true;
      if (location.hash === '#ing-cherub-form') { if (sheetSign) sheetSign.textContent = d.doneSign || sheetSign.textContent; open(); }
      else root.classList.add('is-off');
      return;
    }

    /* ----- should it show at all? ----- */
    if (!editor) {
      if (get(DONE)) { root.classList.add('is-off'); return; }
      if ((parseInt(get(HIDE), 10) || 0) > Date.now()) { root.classList.add('is-off'); return; }
    }

    function appear() {
      if (shown) return; shown = true;
      clearTimeout(timer); window.removeEventListener('scroll', onScroll);
      float.classList.add('is-in');
      fitAll();
    }
    function onScroll() { if (window.scrollY > Math.min(240, window.innerHeight * 0.3)) appear(); }
    var timer = setTimeout(appear, editor ? 0 : (parseFloat(d.delay) || 0) * 1000);
    window.addEventListener('scroll', onScroll, { passive: true });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitAll);

    // step aside while the Bless Yourself sign-up is on screen, so there are never two offers at once
    var font = document.querySelector('[data-ing-font]');
    if (font && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { es.forEach(function (e) { root.classList.toggle('is-tucked', e.isIntersecting); }); }, { threshold: 0.15 }).observe(font);
    }

    welcome();

    /* ----- sign-up ----- */
    function welcome() {
      var endpoint = (d.endpoint || '').replace(/\/$/, '');
      if (!endpoint || !form) return;
      var btn = form.querySelector('button[type=submit]'), input = form.querySelector('input[type=email]');
      if (!btn || !input) return;
      var busy = false;
      function start(e) {
        if (form.__ingGo) return;
        e.preventDefault(); e.stopPropagation();
        if (busy) return;
        var email = input.value.trim();
        if (!email || (input.checkValidity && !input.checkValidity())) { if (input.reportValidity) input.reportValidity(); return; }
        busy = true;
        var label = btn.textContent;
        btn.disabled = true; btn.textContent = 'BLESSING…';
        var old = form.querySelector('.ing-cherub__err'); if (old) old.remove();
        var settled = false;
        function native() {
          if (settled) return; settled = true;
          btn.disabled = false; btn.textContent = label;
          form.__ingGo = true;
          if (form.requestSubmit) form.requestSubmit(btn); else form.submit();
        }
        var timer = setTimeout(native, 12000);
        post(endpoint + '/welcome/signup', { email: email, tags: 'newsletter,cherub-15', code: true }).then(function (j) {
          if (settled) return;
          clearTimeout(timer);
          if (j.__status === 400) {
            settled = true; busy = false;
            btn.disabled = false; btn.textContent = label;
            var p = document.createElement('p'); p.className = 'ing-lbl ing-cherub__err'; p.setAttribute('role', 'alert');
            p.textContent = j.error || 'THAT E-MAIL LOOKS OFF. TRY AGAIN?';
            input.closest('label').insertAdjacentElement('afterend', p); input.focus();
            return;
          }
          if (!j.ok) return native();
          settled = true;
          thanks(j);
        }).catch(function () { clearTimeout(timer); native(); });
      }
      // Shopify's bot check can grab the form's submit, so catch the tap and Enter first
      btn.addEventListener('click', start, true);
      input.addEventListener('keydown', function (e) { if (e.key === 'Enter') start(e); });
      form.addEventListener('submit', function (e) { if (!form.__ingGo) start(e); });
    }

    function thanks(j) {
      signedUp = true; set(DONE, '1');
      try { document.dispatchEvent(new CustomEvent('ing:subscribed', { detail: { from: 'cherub' } })); } catch (e) {}
      form.classList.add('is-leaving');
      setTimeout(function () {
        var title = form.querySelector('.ing-cherub__title');
        form.innerHTML = '<div class="ing-cherub__done" role="status">' +
          (title ? title.outerHTML : '') +
          '<span class="ing-lbl ing-cherub__stamp">' + esc(d.doneStamp) + '</span>' +
          '<div class="ing-cherub__done" data-code aria-live="polite" style="width:100%"></div></div>';
        if (sheetSign && d.doneSign) { sheetSign.textContent = d.doneSign; fit(sheetSign); }
        var box = form.querySelector('[data-code]');
        if (j.code) showCode(box, j);
        else if (j.already) box.innerHTML = '<p class="ing-lbl ing-cherub__msg">YOU WERE ALREADY ON OUR LIST, SO THE 11% CODE IS FOR NEW SIGN-UPS. GOD BLESS!</p>';
        else if (j.had) box.innerHTML = '<p class="ing-lbl ing-cherub__msg">THIS E-MAIL HAS ALREADY RECEIVED ITS 11% CODE.</p>';
        else box.innerHTML = '<p class="ing-lbl ing-cherub__msg">' + esc(j.codeError || 'WE COULDN’T MAKE YOUR CODE JUST NOW. CONTACT US AND WE’LL SEND ONE.') + '</p>';
        form.classList.remove('is-leaving'); form.classList.add('is-arriving');
        var el = form.querySelector('[data-copy]') || form.querySelector('.ing-cherub__stamp');
        if (el) { if (el.tagName !== 'BUTTON') el.setAttribute('tabindex', '-1'); el.focus({ preventScroll: true }); }
      }, quick ? 0 : 320);
    }

    function showCode(box, j) {
      var code = String(j.code), until = '';
      try { until = new Date(j.ends_at).toLocaleString([], { weekday: 'short', month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' }); } catch (e) {}
      var link = d.shopLink || '/collections/all';
      var href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(link.charAt(0) === '/' ? link : '/collections/all');
      box.innerHTML = '<div class="ing-lbl ing-cherub__code-head">' + esc(d.codeHead) + '</div>' +
        '<div class="ing-cherub__code-row"><span class="ing-lbl ing-cherub__code" data-code-val>' + esc(code) + '</span>' +
        '<button class="ing-btn ing-cherub__copy" type="button" data-copy>COPY</button></div>' +
        '<p class="ing-cherub__note">' + esc(d.codeNote) + (until ? ' <span class="ing-lbl">ENDS ' + esc(until.toUpperCase()) + '</span>' : '') + '</p>' +
        '<a class="ing-btn ing-cherub__shop" href="' + href + '">' + esc(d.shopLabel) + '</a>';
      var b = box.querySelector('[data-copy]'), val = box.querySelector('[data-code-val]');
      b.addEventListener('click', function () {
        function ok() { b.textContent = 'COPIED ✓'; setTimeout(function () { b.textContent = 'COPY'; }, 2500); }
        function fallback() { var rg = document.createRange(); rg.selectNodeContents(val); var sel = getSelection(); sel.removeAllRanges(); sel.addRange(rg); try { document.execCommand('copy'); ok(); } catch (e) {} }
        if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(ok, fallback); else fallback();
      });
    }
  }

  function boot() { document.querySelectorAll('[data-ing-cherub]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
